import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CardMedia,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Switch,
  SwitchProps,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import background_linear from "../../assets/images/FrankIcons/linear_background.png";
import React, { useEffect, useRef } from "react";
import {
  defaultLabelColors,
  SHIPMENT_TYPE,
  spacing,
} from "../../utils/constants";

import {
  Add,
  AddPhotoAlternateOutlined,
  Close,
  KeyboardArrowDown,
  Remove,
} from "@mui/icons-material";
import moment from "moment";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AddImageIcon,
  ContinueIcon,
  PlusPackageitemIconNew,
} from "../../assets/images/FrankIcons";
import apiServices from "../../services/RequestHandler";
import { RootState } from "../../Store";
import { strings } from "../../Store/Localization";
import { getAnouncementList } from "../../Store/MainAppReducer";
import CustomAnnouceCard from "../../UiComponent/CustomAnnouceCard";
import CustomButton from "../../UiComponent/CustomButton";
import CustomFooter from "../../UiComponent/CustomFooter";
import DraggableDialog from "../../UiComponent/DraggableDialog";
import NewHeader from "../../UiComponent/NewHeader";
import ParcelSizeSelect from "../../UiComponent/ParcelSizeSelect";
import ScrollToTop from "../../UiComponent/ScrollToTop";
import InputField from "../../UiComponent/TextFeild";
import Toast from "../../UiComponent/Toast/Toast";
import FrankConstants from "../../utils/FrankConstants";
import {
  handleLocalize,
  toBase64,
} from "../../utils/helper";
import { getDataFromLocalStorage } from "../../utils/LocalStore.util";
import AuthAction from "../Auth/AuthAction";
import DropOffInfo from "./DropOffInfo";
import PickupInfo from "./PickupInfo";
import ReviewPackage from "./ReviewPackage";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useTheme } from "@mui/system";
import CustomMobileFooter from "../../UiComponent/CustomMobileFooter";
import MobileResponsive from "../LandingPage/MobileResponsive";
import { Squircle } from "corner-smoothing";

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#65C466",
        opacity: 1,
        border: 0,
        ...theme.applyStyles("dark", {
          backgroundColor: "#2ECA45",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...theme.applyStyles("dark", {
      backgroundColor: "#39393D",
    }),
  },
}));

function SendPackage(props: any) {
  const location = useLocation();
  const navigate = useNavigate();
  const selector = useSelector((state: RootState) => state.mainApp);
  const { classes } = props;
  const [selectedValue, setSelectedValue] = React.useState("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const dispatch = useDispatch<any>();
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      openLoginDialog: false,
      openJobDialog: false,
      isDimestions: false,
      shouldNavigate: false,
      step: 1,
      items: [],
      item_quantity: 1,
      announcement_item: {
        images: [],
      },
      isUpdate: false,
      preventInputClick: false,
      expanded_1: false,
      expanded_2: false,
      expanded_3: false,
      expanded_4: false,
      expanded_5: false,
      expanded_6: false,
      expanded_7: false,
    }
  );
  const theme = useTheme();

  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));

  const handleExpanded = (state_name: any) => {
    try {
      setState({ [state_name]: !state?.[state_name] });
    } catch (error) {}
  };
  useEffect(() => {
    handleGetRecentTransactions();

    dispatch(
      getAnouncementList({
        end_point: "/item-lists/all",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    handleGetAllBlog();
  }, []);

  const handleGetAllBlog = async () => {
    try {
      setState({ activity: true });
      let resp = await apiServices.getFromApi(
        `c2c-blogs/web?page=1&limit=6`,
        ""
      );
      if (resp?.status === 200 || resp?.status === 201) {
        setState({ allBlogs: resp?.data, totalPage: resp?.total_pages });
        setState({ activity: false });
      }
    } catch (error) {
      setState({ activity: false });
    }
  };

  useEffect(() => {
    console.log("RE-RENDER");
  }, [selector.lang]);

  const handleEmptyShipment = () => {
    try {
      setState({
        items: [],
        announcement_item: {
          images: [],
        },
        item_quantity: 1,
      });
    } catch (error) {}
  };
  const handleIncrmntDecrmnt = (state_name: string) => {
    try {
      if (state_name === "increament") {
        setState({
          item_quantity: state?.item_quantity + 1,
        });
      }
      if (state_name === "decrement" && state?.item_quantity > 1) {
        setState({
          item_quantity: state?.item_quantity - 1,
        });
      }
    } catch (error) {}
  };

  const handleCloseLoginPage = () => {
    try {
      setState({ openLoginDialog: false });
    } catch (error) {}
  };
  const handleUpdateState = (state_name: string, data: any) =>
    setState({
      ...state,
      [state_name]: data,
      step: state.step + 1,
    });

  const _handleUpdateState = (state_name: string, data: any) =>
    setState({
      [state_name]: data,
    });

   

  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedValue(event.target.value);
  };

  const onInputChange = (e: any) => {
    try {
      const { value, name } = e.target;
      if (value[0] === " ") {
        return;
      }

      setState({
        [name]: value,
      });
    } catch (error) {}
  };

  const onInputChangeForDimensions = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      let { value, name } = e.target;

      // Allow only digits and up to two decimal places
      const re = /^\d*\.?\d{0,2}$/;

      // Ensure the value is either empty or matches the regular expression
      if (value === "" || re.test(value)) {
        // Prevent leading space, negative numbers, or starting with a period
        if (
          value[0] === " " ||
          parseFloat(value) < 0 ||
          value[0] === "." ||
          (value.length > 1 && value[0] === "0" && !value.includes("."))
        ) {
          return;
        }

        // Limit the input to values up to 10,000
        if (parseFloat(value) > 10000) {
          return;
        }

        // Set the state with the valid value
        setState({
          [name]: value,
        });
      }
    } catch (error) {
      console.error("Error in onInputChangeForDimensions:", error);
    }
  };

  const handleGetRecentTransactions = async () => {
    try {
      let resp = await apiServices.getFromApi(
        "c2c-shipments/get-recent-by-customer",
        ""
      );
      setState({
        recentTransactions: resp?.data,
      });
    } catch (error) {}
  };

  const handleOpenDialog = () => {
    try {
      setState({ openJobDialog: true });
    } catch (error) {}
  };

  const handleLaunchGallery2 = async (
    state_name: string,
    index: number,
    file: any
  ) => {
    try {
      if (!state?.preventInputClick) {
        const selectedFile = file.target.files[0];

        const allowedImageTypes = ["image/jpeg", "image/png", "image/gif"];

        if (!selectedFile || !allowedImageTypes.includes(selectedFile.type)) {
          alert("Please upload a valid image file (jpg, png, gif).");
          return;
        }
        let { announcement_item } = state;
        let item_obj = {
          ...announcement_item,
        };
        item_obj.images[index] = {
          file: file.target.files[0],
          uri: await toBase64(file.target.files[0]),
        };
        setState({
          announcement_item: item_obj,
        });
      }
      setState({ preventInputClick: false });
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveImage = (index: number) => {
    setState({ preventInputClick: true });

    let { announcement_item } = state;
    let item_obj = {
      ...announcement_item,
    };

    item_obj.images.splice(index, 1);

    setState({
      announcement_item: item_obj,
    });
  };

  const handleClick = () => {
    if (!state?.preventInputClick) {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    }
    setState({ preventInputClick: false }); // Reset the flag after the click is handled
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      let { announcement_item } = state;
      let item_obj = {
        ...announcement_item,
      };
      if (item_obj?.images?.length >= 6) {
        Toast.Error("Vous ne pouvez pas ajouter plus de 6 photos");
        return;
      }
      const file = files[0];
      const base64 = await toBase64(file);
      item_obj?.images?.push({
        file,
        uri: base64,
      });
      setState({
        announcement_item: item_obj,
      });
    }
  };

  const EditShipmentItem = (item: any, idx: any) => {
    try {
      setSelectedValue(item?.productSize?.size);
      setState({
        current_index: idx,
        openJobDialog: true,
        item_quantity: item?.prod_quantity,
        prod_length: item?.productLength,
        prod_width: item?.productWidth,
        prod_height: item?.productHeight,
        additional_info: item?.product_additionalInfo,
        isFragile: item?.is_fragile,
        isDimestions: item?.isDimestions,
        announcement_item: {
          images: item?.images,
        },
        selected_value: item?.packageType,
        isUpdate: true,
      });
    } catch (error) {}
  };

  const handleClearAllFeils = () => {
    try {
      setState({
        openJobDialog: false,
        selected_value: null,
        item_quantity: 1,
        prod_length: "",
        prod_width: "",
        prod_height: "",
        additional_info: "",
        isFragile: false,
        isDimestions: false,
        announcement_item: {
          images: [],
        },
        isUpdate: false,
      });
      setSelectedValue("");
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleAddShipment = () => {
    const { announcement_item } = state;
    if (state?.announcement_item?.images?.length < 1) {
      Toast.Error(strings.product_image_error);
      return;
    }
    if (!state.selected_value?.label) {
      Toast.Error(strings?.item_name_error);
      return;
    }
    if (!selectedValue) {
      Toast.Error(strings?.select_size);
      return;
    }

    let shipment_size = SHIPMENT_TYPE?.filter(
      (i) => i?.size === selectedValue
    )[0];

    const updatedItem = {
      ...announcement_item,
      id: state?.item_id,
      packageType: state.selected_value,
      prod_quantity: state?.item_quantity ?? 1,
      productLength: state?.prod_length,
      productWidth: state?.prod_width,
      productHeight: state?.prod_height,
      product_additionalInfo: state.additional_info ?? "",
      is_fragile: state?.isFragile ?? false,
      productSize: shipment_size,
      isDimestions: state?.isDimestions ?? false,
    };

    state?.items.push(updatedItem);

    handleClearAllFeils();
  };

  const handleUpdateShipment = (id: any, index: any) => {
    const { announcement_item } = state;

    if (announcement_item?.images?.length < 1) {
      Toast.Error(strings.product_image_error);
      return;
    }
    if (
      state?.current_index < 0 ||
      state?.current_index >= state.items?.length
    ) {
      console.error("Invalid index:", state?.current_index);
      return;
    }

    let shipment_size = SHIPMENT_TYPE?.filter((i) => i?.size === selectedValue);

    if (!state.selected_value?.label) {
      Toast.Error(strings?.item_name_error);
      return;
    }

    const updated_data = {
      ...announcement_item,
      id: state?.item_id,
      packageType: state.selected_value,
      prod_quantity: state?.item_quantity ?? 1,
      productLength: state?.prod_length,
      productWidth: state?.prod_width,
      productHeight: state?.prod_height,
      product_additionalInfo: state.additional_info ?? "",
      is_fragile: state?.isFragile ?? false,
      productSize: shipment_size?.length ? shipment_size[0] : null,
      isDimestions: state?.isDimestions ?? false,
    };

    // const updatedItems = state.items.map((item: any) =>
    //   item.id === state?.current_id ? { ...item, ...updated_data } : item
    // );

    const updatedItems = [...state.items];
    updatedItems[state?.current_index] = {
      ...updatedItems[state?.current_index],
      ...updated_data,
    };

    if (updatedItems) {
      setState({
        ...state,
        items: updatedItems,
        openJobDialog: false,
        isUpdate: false,
      });
    }

    handleClearAllFeils();
  };

  const handleContinue = () => {
    try {
      if (state?.items?.length < 1) {
        handleOpenDialog();
        return;
      }

      const token = getDataFromLocalStorage("token");

      if (!token) {
        setState({ openLoginDialog: true });

        return;
      }

      setState({
        step: state?.step + 1,
      });
    } catch (error) {}
  };

  const handleRemoveItem = (id: any, idx: any) => {
    try {
      state?.items?.splice(idx, 1);

      setState({});
      handleClearAllFeils();
    } catch (error) {}
  };

  const handleShipmentTypeChange = (
    value: any | { label: any; value: any }
  ) => {
    setState({
      item_id: value?.id,
      prod_name:
        handleLocalize({
          en: value?.item_name_en,
          fr: value?.item_name_fr,
        }) ?? "",
      prod_length: value?.length ?? 0,
      prod_width: value?.width ?? 0,
      prod_height: value?.height ?? 0,
      // prod_size: product_size,
      selected_value: value,
    });
  };

  const transSizes = (item: any) => {
    const deliveryType = FrankConstants.itemSizes(selector.lang)?.find(
      (a: any) => a.size === item
    );
    return deliveryType?.size_trans;
  };

  return (
    <>
      <Helmet>
        <title>Déménager entre particuliers - Frank</title>
        <link
          rel="canonical"
          href="https://www.frank.fr/send-package"
        />
        <link
          rel="icon"
          type="image/png"
          href="../../assets/images/FrankIcons/favicon.ico"
        />
        <meta
          name="description"
          content="Envoyez vos colis entre particuliers avec Frank pour une livraison économique, écologique, et moins chère partout en France. Rejoignez notre réseau de livraison collaborative."
        />
      </Helmet>
      <div className="web-screen">
        <div
          style={{
            background: defaultLabelColors.main_background_new,
            justifyItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ScrollToTop />
          <div
            style={{
              maxWidth: 1408,
              width: "100%",
            }}
          >
            <NewHeader
              showContent={state?.step === 1 ? true : false}
              centeredLogo={state?.step !== 1 && !screen_1024 ? true : false}
            />
            <div
              style={{
                paddingTop: 80,
                paddingBottom: 30,
                paddingLeft: 40,
                paddingRight: 40,
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  background: defaultLabelColors.main_background,
                  paddingTop: "50px",
                }}
              >
                <ScrollToTop />
              </div>

              {state?.step === 1 ? (
                <>
                  <div
                    style={{
                      background: defaultLabelColors.main_background,
                    }}
                  >
                    <Grid
                      container
                      spacing={spacing.spacing2}
                      style={{ height: "100%", paddingBottom: "10px" }}
                    >
                      <Grid xs={12} item>
                        <h1
                          style={{
                            fontFamily: "montserrat-Bold",
                            color: "#000",
                            fontSize: 28,
                          }}
                        >
                          {location?.pathname === "/relocation"
                            ? "DÉMÉNAGER "
                            : "Envoyer un colis entre "}
                          <span style={{ color: "#2D26E6" }}>
                            particuliers !
                          </span>
                        </h1>
                        <p
                          className="paragraph-text-two"
                          style={{
                            marginTop: screen_1024 ? "-10px" : "",
                            fontSize: "16px",
                          }}
                        >
                          Vous voulez envoyer un colis sans vous ruiner ?{" "}
                          {screen_1024 ? null : <br />} Découvrez la livraison
                          collaborative avec Frank!
                          <br />
                          Notre service innovant vous permet de faire livrer vos
                          colis par des particuliers. Un moyen économique et
                          écologique d'expédier vos paquets partout en France.
                        </p>

                        <h2
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            paddingBottom: 10,
                            fontSize: 16,
                            color: "#000",
                            marginTop: 30,
                          }}
                        >
                          Déposez votre annonce
                        </h2>
                      </Grid>
                    </Grid>

                    <Squircle
                      cornerRadius={16}
                      cornerSmoothing={0.6}
                      preserveSmoothing={true}
                      style={{
                        background: "#fff",
                        padding: "0px 16px 16px 16px",
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                        sx={{
                          display: "flex",
                          flexDirection: screen_1024 ? "row" : "column-reverse",
                        }}
                      >
                        {state?.items?.map((i: any, idx: any) => {
                          return (
                            <Grid xs={12} md={screen_1024 ? 6 : 12} item>
                              <Squircle
                                cornerRadius={16}
                                cornerSmoothing={0.6}
                                preserveSmoothing={true}
                                style={{
                                  background: "#f4f3f6",
                                  borderRadius: "16px",
                                }}
                              >
                                <CustomAnnouceCard
                                  productImage={i?.images?.[0]?.uri}
                                  imageQuantity={i?.images?.length}
                                  productLength={i?.productLength}
                                  productWidth={i?.productWidth}
                                  productheight={i?.productHeight}
                                  productSize={
                                    i?.productSize[0]?.size ??
                                    i?.productSize?.size
                                  }
                                  productTitle={handleLocalize({
                                    fr: i?.packageType?.item_name_fr,
                                    en: i?.packageType?.item_name_en,
                                  })}
                                  shipmentQuantity={i?.prod_quantity}
                                  handleEdit={() => EditShipmentItem(i, idx)}
                                  handleRemove={() => handleRemoveItem(i, idx)}
                                />
                              </Squircle>
                            </Grid>
                          );
                        })}
                        <Grid
                          xs={12}
                          md={screen_1024 && state?.items?.length % 2 ? 6 : 12}
                          item
                          onClick={handleOpenDialog}
                          style={{
                            display: "flex",
                          }}
                        >
                          <div
                            className="display-flex"
                            style={{
                              width: "100%",
                              flexDirection: screen_1024 ? "column" : "row",
                              gap: 10,
                              border: "1px dashed  #EF6A31",
                              background: "#F4F4FD",
                              padding: "30px",
                              borderRadius: "16px",
                              cursor: "pointer",
                            }}
                          >
                            <PlusPackageitemIconNew
                              height={24}
                              fill={defaultLabelColors.main_orange_new}
                            />
                            <p
                              style={{
                                fontFamily: "montserrat-Bold",
                                color: defaultLabelColors.main_orange_new,
                                fontSize: screen_1024 ? "16px" : "14px",
                                margin: screen_1024
                                  ? "-1px 0px 0px 0px "
                                  : "14px 0px",
                              }}
                            >
                              {strings?.add_item}
                            </p>
                          </div>
                        </Grid>
                      </Grid>
                    </Squircle>

                    <Grid container spacing={spacing.spacing2}>
                      <Grid
                        xs={12}
                        item
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          paddingTop: "40px",
                        }}
                      >
                        <CustomButton
                          style={{ fontFamily: "montserrat-Regular" }}
                          disable={state?.items?.length === 0 ? true : false}
                          classesNames={
                            state?.items?.length === 0
                              ? "disable_contained_button_for_nego"
                              : "contained_button_for_nego"
                          }
                          onClick={handleContinue}
                          value={
                            <React.Fragment>
                              <div
                                className="display-flex"
                                style={{
                                  columnGap: "20px",
                                }}
                              >
                                {strings?.continue_}
                                <ContinueIcon
                                  stroke={
                                    state?.items?.length === 0
                                      ? "#E9E8EB"
                                      : "white"
                                  }
                                />
                              </div>
                            </React.Fragment>
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      spacing={1}
                      style={{
                        paddingTop: screen_1024 ? "100px" : "50px",
                        paddingBottom: screen_1024 ? "100px" : "0px",
                      }}
                    >
                      {screen_1024 ? (
                        <Grid xs={12} item>
                          <Squircle
                            cornerRadius={16}
                            cornerSmoothing={0.6}
                            preserveSmoothing={true}
                            className="triangle"
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              gap: "5px",
                              paddingRight: "60px",
                              paddingLeft: "20px",
                            }}
                          >
                            <div
                              style={{
                                fontFamily: "montserrat-Bold",
                                color: "#fff",
                                fontSize: "32px",
                                // width: "25%",
                                minWidth: "252px",
                              }}
                            >
                              Comment ça <br /> fonctionne ?
                            </div>
                            <Squircle
                              cornerRadius={16}
                              cornerSmoothing={0.6}
                              preserveSmoothing={true}
                              style={{
                                display: "flex",
                                width: "302px",
                                height: 150,
                                justifyContent: "center",
                                alignItems: "flex-start",
                                gap: "10px",
                                flexDirection: "column",
                              }}
                              className="mstpone_1_pkg"
                            >
                              <div>
                                <span
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    color: "#fff",
                                    background: defaultLabelColors.main_orange,
                                    borderRadius: 100,
                                    fontSize: "25px",
                                    padding: "5px 18px 10px 18px",
                                    textAlign: "left",
                                    marginLeft: 20,
                                  }}
                                >
                                  1
                                </span>
                              </div>

                              <div
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "montserrat-Bold",
                                  color: defaultLabelColors.main_blue,
                                  textAlign: "left",
                                  padding: "0px 5px 0px 5px",
                                  marginLeft: 20,
                                  marginTop: 15,
                                }}
                              >
                                Créez votre annonce
                              </div>
                            </Squircle>

                            <Squircle
                              cornerRadius={16}
                              cornerSmoothing={0.6}
                              preserveSmoothing={true}
                              style={{
                                display: "flex",
                                width: "302px",
                                height: 150,
                                justifyContent: "center",
                                alignItems: "flex-start",
                                gap: "10px",
                                flexDirection: "column",
                              }}
                              className="mstpone_1_pkg"
                            >
                              <div>
                                <span
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    color: "#fff",
                                    background: defaultLabelColors.main_blue,
                                    borderRadius: 100,
                                    fontSize: "25px",
                                    padding: "5px 15px 10px 15px",
                                    textAlign: "left",
                                    marginLeft: "20px",
                                  }}
                                >
                                  2
                                </span>
                              </div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "montserrat-Bold",
                                  color: defaultLabelColors.main_blue,
                                  textAlign: "left",
                                  padding: "0px 5px 0px 5px",
                                  marginLeft: 20,
                                }}
                              >
                                Mentionnez le prix <br /> de votre choix
                              </div>
                            </Squircle>

                            <Squircle
                              cornerRadius={16}
                              cornerSmoothing={0.6}
                              preserveSmoothing={true}
                              style={{
                                display: "flex",
                                width: "302px",
                                height: 150,
                                justifyContent: "center",
                                alignItems: "flex-start",
                                gap: "10px",
                                flexDirection: "column",
                              }}
                              className="mstpone_1_pkg"
                            >
                              <div>
                                <span
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    color: "#fff",
                                    background: defaultLabelColors.main_orange,
                                    borderRadius: 100,
                                    fontSize: "25px",
                                    padding: "5px 15px 10px 15px",
                                    // textAlign: "center",
                                    marginLeft: 20,
                                  }}
                                >
                                  3
                                </span>
                              </div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "montserrat-Bold",
                                  color: defaultLabelColors.main_blue,
                                  textAlign: "left",
                                  padding: "0px 5px 0px 5px",
                                  marginLeft: 20,
                                }}
                              >
                                Attendez que l’annonce <br />
                                trouve un transporteur
                              </div>
                            </Squircle>
                          </Squircle>
                        </Grid>
                      ) : (
                        <div
                          style={{
                            maxHeight: "100%",

                            maxWidth: "100%",
                            backgroundImage: `url(${background_linear})`,
                            backgroundSize: "cover",
                            backgroundRepeat: "round",
                            display: "flex",
                            objectFit: "contain",
                            flexDirection: "column",
                            borderRadius: "24px",
                            padding: 16,
                            gap: 16,
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "montserrat-Bold",
                              color: "#fff",
                              fontSize: "24px",
                              // width: "25%",
                              minWidth: "252px",
                              textAlign: "center",
                              marginTop: "16px",
                            }}
                          >
                            Comment <br /> ça fonctionne ?
                          </div>

                          <div style={{ display: "flex", gap: 16 }}>
                            <div
                              style={{
                                display: "flex",
                                width: "302px",
                                height: 150,
                                borderRadius: "16px",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                gap: "10px",
                                flexDirection: "column",
                              }}
                              className="mstpone_1_pkg"
                            >
                              <div>
                                <span
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    color: "#fff",
                                    background: defaultLabelColors.main_orange,
                                    borderRadius: 100,
                                    fontSize: "24px",
                                    padding: "5px 18px 10px 18px",
                                    textAlign: "left",
                                    marginLeft: 20,
                                  }}
                                >
                                  1
                                </span>
                              </div>

                              <div
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "montserrat-Bold",
                                  color: defaultLabelColors.main_blue,
                                  textAlign: "left",
                                  padding: "0px",
                                  marginLeft: 20,
                                  marginTop: 15,
                                }}
                              >
                                Créez votre <br></br> annonce
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                width: "302px",
                                height: 150,
                                borderRadius: "16px",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                gap: "10px",
                                flexDirection: "column",
                              }}
                              className="mstpone_1_pkg"
                            >
                              <div>
                                <span
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    color: "#fff",
                                    background: defaultLabelColors.main_blue,
                                    borderRadius: 100,
                                    fontSize: "24px",
                                    padding: "5px 15px 10px 15px",
                                    textAlign: "left",
                                    marginLeft: "20px",
                                  }}
                                >
                                  2
                                </span>
                              </div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "montserrat-Bold",
                                  color: defaultLabelColors.main_blue,
                                  textAlign: "left",
                                  padding: "0px",
                                  marginTop: "10px",
                                  marginLeft: 20,
                                }}
                              >
                                Mentionnez le prix <br /> de votre choix
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                width: "302px",
                                height: 150,
                                borderRadius: "16px",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                gap: "10px",
                                flexDirection: "column",
                              }}
                              className="mstpone_1_pkg"
                            >
                              <div>
                                <span
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    color: "#fff",
                                    background: defaultLabelColors.main_orange,
                                    borderRadius: 100,
                                    fontSize: "24px",
                                    padding: "5px 15px 10px 15px",
                                    // textAlign: "center",
                                    marginLeft: 20,
                                  }}
                                >
                                  3
                                </span>
                              </div>
                              <div
                                style={{
                                  fontSize: "15px",
                                  fontFamily: "montserrat-Bold",
                                  color: defaultLabelColors.main_blue,
                                  textAlign: "left",
                                  padding: "0px",
                                  marginLeft: 10,
                                  marginTop: "10px",
                                }}
                              >
                                Attendez que l’annonce trouve un transporteur
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Grid>

                    <div>
                      <Grid
                        container
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <h2
                            style={{
                              textAlign: "left",
                              fontSize: screen_1024 ? "28px" : "22px",
                              padding: "40px 0px 20px 0px",
                              margin: 0,
                              color: "#000",
                            }}
                            className="montserrat-Bold"
                          >
                            Nos Actualités
                          </h2>
                          <ul className="cards">
                            <Grid container spacing={4}>
                              {state?.allBlogs
                                ?.slice(0, 3)
                                ?.map((item: any) => {
                                  return (
                                    <>
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={screen_1024 ? 4 : 6}
                                        // className="cards__item"
                                        style={{
                                          display: "flex",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          navigate(
                                            `/blog-details/${item?.blog_cat_id}/${item?.id}`
                                          );
                                        }}
                                      >
                                        <div className="card">
                                          <CardMedia
                                            component="img"
                                            style={{
                                              minHeight: screen_1024
                                                ? 296
                                                : 220,
                                              objectFit: "cover",
                                              borderRadius: 8,
                                            }}
                                            image={
                                              item?.blog_image?.[1] ??
                                              item?.blog_image?.[0]
                                            } // Replace with the image URL you need
                                            alt="Blog card image"
                                          />
                                          <div
                                            className="card__content"
                                            style={{ gap: 10 }}
                                          >
                                            <div style={{ display: "flex" }}>
                                              <div
                                                className="card__title"
                                                style={{ flex: 1 }}
                                              >
                                                {handleLocalize(item?.title)}
                                              </div>
                                            </div>
                                            {screen_1024 ? (
                                              <p
                                                className="card__text"
                                                style={{
                                                  margin: 0,
                                                  maxLines: 4,
                                                }}
                                              >
                                                {handleLocalize(
                                                  item?.sub_title
                                                )}
                                              </p>
                                            ) : null}
                                            <p
                                              style={{
                                                fontSize: "16px",
                                                color: "#78778A",
                                                fontWeight: "400",
                                                margin: 0,
                                              }}
                                              className="montserrat-Regular"
                                            >
                                              {moment(
                                                `${item?.created_at}`.endsWith(
                                                  "Z"
                                                )
                                                  ? item?.created_at
                                                  : item?.created_at + "Z"
                                              ).format("DD MMMM YYYY")}{" "}
                                              {screen_1024 ? (
                                                <span
                                                  style={{
                                                    fontFamily:
                                                      "montserrat-SemiBold",
                                                    textDecoration: "underline",
                                                    color: "#000",
                                                    paddingLeft: 5,
                                                  }}
                                                >
                                                  {handleLocalize(
                                                    item?.category_name
                                                  )}
                                                </span>
                                              ) : null}
                                            </p>
                                            {screen_1024 ? (
                                              <div>
                                                <CustomButton
                                                  style={{
                                                    padding: "9px 21px",
                                                  }}
                                                  onClick={() => {
                                                    navigate(
                                                      "/transporter-un-colis"
                                                    );
                                                  }}
                                                  classesNames={
                                                    "new_contained_button"
                                                  }
                                                  value={"En savoir plus"}
                                                />
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>
                                      </Grid>
                                    </>
                                  );
                                })}
                            </Grid>
                          </ul>
                        </div>
                      </Grid>
                      <div className="display-flex">
                        <Grid
                          container
                          spacing={2}
                          marginTop={5}
                          style={{
                            padding: 10,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Grid
                            xs={12}
                            item
                            className="display-flex"
                            style={{
                              flexDirection: "column",
                              padding: "10px",
                              borderRadius: "18px",
                            }}
                          >
                            <h3
                              style={{
                                fontSize: "28px",
                                fontFamily: "montserrat-Bold ",
                                display: "flex",
                                width: "100%",
                                margin: 0,
                                color: defaultLabelColors.main_font_brown,
                              }}
                            >
                              FAQ
                            </h3>
                            <Grid
                              xs={12}
                              item
                              className="display-flex"
                              style={{
                                flexDirection: "column",
                                borderRadius: "18px",
                                gap: 20,
                              }}
                            >
                              <Accordion
                                elevation={0}
                                style={{
                                  border: "0px",
                                  background: "#FFF8F5",
                                  width: "100%",
                                }}
                                expanded={state?.expanded_1}
                                onChange={() => handleExpanded("expanded_1")}
                              >
                                <AccordionSummary
                                  style={{ border: "none", marginTop: 20 }}
                                  // expandIcon={<AddIcon />}
                                  expandIcon={
                                    state?.expanded_1 ? (
                                      <RemoveIcon
                                        style={{
                                          color:
                                            defaultLabelColors.main_orange_new,
                                        }}
                                      />
                                    ) : (
                                      <AddIcon />
                                    )
                                  }
                                  className="faq-comments"
                                  sx={{
                                    "&.Mui-expanded h3": {
                                      color:
                                        defaultLabelColors?.main_orange_new,
                                    },
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontWeight: "500",
                                      fontFamily: "montserrat-Medium",
                                      fontSize: screen_1024 ? "22px" : "18px",
                                    }}
                                  >
                                    Quels type de colis puis-je envoyer avec
                                    Frank ?
                                  </h3>
                                </AccordionSummary>
                                <AccordionDetails
                                  style={{
                                    width: "90%",
                                    fontFamily: "montserrat-Regular",
                                    color: "#4B4A61",
                                    fontSize: 18,
                                  }}
                                >
                                  <p>
                                    Particuliers ou professionnels, vous pouvez
                                    expédier toutes sortes de colis via notre
                                    plateforme :
                                  </p>
                                  <p>
                                    1. Des petits paquets : cadeaux, vêtements,
                                    livres, etc.{" "}
                                  </p>
                                  <p>
                                    2. Des colis moyens : appareils
                                    électroménagers, meubles en kit, vélos,
                                    matériel de sport, etc.{" "}
                                  </p>
                                  <p>
                                    3. Des envois volumineux : cartons de
                                    déménagement, gros électroménager, meubles,
                                    etc
                                  </p>
                                  <p>
                                    Il n'y a pas de limite de poids. Tant qu'un
                                    particulier accepte de transporter votre
                                    colis ! Avec Frank, vous pouvez même
                                    organiser votre déménagement !
                                  </p>
                                </AccordionDetails>
                              </Accordion>

                              <Accordion
                                elevation={0}
                                style={{
                                  border: "0px",
                                  background: "#FFF8F5",
                                  width: "100%",
                                }}
                                expanded={state?.expanded_2}
                                onChange={() => handleExpanded("expanded_2")}
                              >
                                <AccordionSummary
                                  style={{ border: "none", marginTop: 20 }}
                                  expandIcon={
                                    state?.expanded_2 ? (
                                      <RemoveIcon
                                        style={{
                                          color:
                                            defaultLabelColors.main_orange_new,
                                        }}
                                      />
                                    ) : (
                                      <AddIcon />
                                    )
                                  } // Dynamic icon change
                                  className="faq-comments"
                                  sx={{
                                    "&.Mui-expanded h3": {
                                      color:
                                        defaultLabelColors?.main_orange_new,
                                    }, // Change h3 color when expanded
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontWeight: "500",
                                      fontFamily: "montserrat-Medium",
                                      fontSize: screen_1024 ? "22px" : "18px",
                                      padding: "20px 0px",
                                    }}
                                  >
                                    Où faut-il déposer mon colis ?
                                  </h3>
                                </AccordionSummary>
                                <AccordionDetails
                                  style={{
                                    width: "90%",
                                    fontFamily: "montserrat-Regular",
                                    color: "#4B4A61",
                                    fontSize: 18,
                                  }}
                                >
                                  <p>
                                    {" "}
                                    Vous convenez d'un point de rendez-vous avec
                                    le particulier qui assurera le transport de
                                    colis. Cela peut être
                                    :ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                                  </p>

                                  <p> • À votre domicile</p>
                                  <p>
                                    {" "}
                                    • Sur son lieu de départ (gare, aéroport,
                                    etc.)
                                  </p>

                                  <p>
                                    L'application vous permet de choisir le lieu
                                    le plus pratique et d'échanger avec le
                                    transporteur pour organiser la remise du
                                    colis en toute simplicité.
                                  </p>
                                </AccordionDetails>
                              </Accordion>

                              <Accordion
                                elevation={0}
                                style={{
                                  border: "0px",
                                  background: "#FFF8F5",
                                }}
                                expanded={state?.expanded_3}
                                onChange={() => handleExpanded("expanded_3")}
                              >
                                <AccordionSummary
                                  style={{ border: "none", marginTop: 20 }}
                                  expandIcon={
                                    state?.expanded_3 ? (
                                      <RemoveIcon
                                        style={{
                                          color:
                                            defaultLabelColors.main_orange_new,
                                        }}
                                      />
                                    ) : (
                                      <AddIcon />
                                    )
                                  } // Dynamic icon change
                                  className="faq-comments"
                                  sx={{
                                    "&.Mui-expanded h3": {
                                      color:
                                        defaultLabelColors?.main_orange_new,
                                    }, // Change h3 color when expanded
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontWeight: "500",
                                      fontFamily: "montserrat-Medium",
                                      fontSize: screen_1024 ? "22px" : "18px",
                                      padding: "20px 0px",
                                    }}
                                  >
                                    Existe-t-il un poids maximum pour l’envoie
                                    d’un colis entre particuliers ?{" "}
                                  </h3>
                                </AccordionSummary>
                                <AccordionDetails
                                  style={{
                                    width: "90%",
                                    fontFamily: "montserrat-Regular",
                                    color: "#4B4A61",
                                    fontSize: 18,
                                  }}
                                >
                                  <p>
                                    Non, il n'y a pas de limite de poids chez
                                    Frank, contrairement à de nombreux
                                    transporteurs. Notre réseau de particuliers
                                    nous permet d'acheminer même les colis les
                                    plus lourds et encombrants.
                                  </p>
                                  <p>
                                    C'est idéal pour les déménagements par
                                    exemple. Vous pouvez indiquer le volume et
                                    le nombre de personnes requises, et
                                    constituer une équipe de Frankies pour vous
                                    aider !
                                  </p>
                                </AccordionDetails>
                              </Accordion>

                              <Accordion
                                elevation={0}
                                style={{
                                  border: "0px",
                                  background: "#FFF8F5",
                                }}
                                expanded={state?.expanded_4}
                                onChange={() => handleExpanded("expanded_4")}
                              >
                                <AccordionSummary
                                  style={{ border: "none", marginTop: 20 }}
                                  // expandIcon={<AddIcon />}
                                  expandIcon={
                                    state?.expanded_4 ? (
                                      <RemoveIcon
                                        style={{
                                          color:
                                            defaultLabelColors.main_orange_new,
                                        }}
                                      />
                                    ) : (
                                      <AddIcon />
                                    )
                                  } // Dynamic icon change
                                  className="faq-comments"
                                  sx={{
                                    "&.Mui-expanded h3": {
                                      color:
                                        defaultLabelColors?.main_orange_new,
                                    }, // Change h3 color when expanded
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontWeight: "500",
                                      fontFamily: "montserrat-Medium",
                                      fontSize: screen_1024 ? "22px" : "18px",
                                      padding: "20px 0px",
                                    }}
                                  >
                                    Puis-je envoyer plusieurs colis en même
                                    temps ?{" "}
                                  </h3>
                                </AccordionSummary>
                                <AccordionDetails
                                  style={{
                                    width: "90%",
                                    fontFamily: "montserrat-Regular",
                                    color: "#4B4A61",
                                    fontSize: 18,
                                  }}
                                >
                                  <p>
                                    Oui, avec Frank vous pouvez grouper vos
                                    expéditions sans problème. Au moment de
                                    publier votre annonce, précisez simplement
                                    le nombre de colis à envoyer en appuyant sur
                                    le “ + “. Notre système adapté fera en sorte
                                    de trouver le transporteur adéquat, qu'il
                                    s'agisse de quelques paquets ou d'une
                                    cargaison complète.
                                  </p>
                                  <p>
                                    Vous pouvez aussi envoyer plusieurs colis à
                                    plusieurs destinations différentes. Dans ce
                                    cas, il faudra publier une annonce par
                                    colis.
                                  </p>
                                </AccordionDetails>
                              </Accordion>

                              <Accordion
                                elevation={0}
                                style={{
                                  border: "0px",
                                  background: "#FFF8F5",
                                }}
                                expanded={state?.expanded_5}
                                onChange={() => handleExpanded("expanded_5")}
                              >
                                <AccordionSummary
                                  style={{ border: "none", marginTop: 20 }}
                                  // expandIcon={<AddIcon />}
                                  expandIcon={
                                    state?.expanded_5 ? (
                                      <RemoveIcon
                                        style={{
                                          color:
                                            defaultLabelColors.main_orange_new,
                                        }}
                                      />
                                    ) : (
                                      <AddIcon />
                                    )
                                  } // Dynamic icon change
                                  className="faq-comments"
                                  sx={{
                                    "&.Mui-expanded h3": {
                                      color:
                                        defaultLabelColors?.main_orange_new,
                                    }, // Change h3 color when expanded
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontWeight: "500",
                                      fontFamily: "montserrat-Medium",
                                      fontSize: screen_1024 ? "22px" : "18px",
                                      padding: "20px 0px",
                                    }}
                                  >
                                    Quelle assurance est disponible pour mon
                                    colis ?{" "}
                                  </h3>
                                </AccordionSummary>
                                <AccordionDetails
                                  style={{
                                    width: "90%",
                                    fontFamily: "montserrat-Regular",
                                    color: "#4B4A61",
                                    fontSize: 18,
                                  }}
                                >
                                  <p>
                                    Chez Frank, la sécurité de vos colis est
                                    notre priorité.C'est pourquoi chaque envoi
                                    réalisé via notre service de livraison
                                    collaborative est automatiquement assuré à
                                    hauteur de 100€, sans frais supplémentaires.
                                  </p>
                                  <p>
                                    Mais si votre colis a une valeur supérieure,
                                    pas de panique ! Grâce à notre partenariat
                                    avec un assureur indépendant, vous pouvez
                                    souscrire à une garantie renforcée qui
                                    couvrira intégralement votre bien en cas de
                                    vol, casse ou incident pendant le transport.
                                  </p>
                                  <p>
                                    Par ailleurs, notre plateforme collaborative
                                    nous permet de sélectionner des livreurs de
                                    confiance.
                                  </p>
                                </AccordionDetails>
                              </Accordion>

                              <Accordion
                                elevation={0}
                                style={{
                                  border: "0px",
                                  background: "#FFF8F5",
                                }}
                                expanded={state?.expanded_6}
                                onChange={() => handleExpanded("expanded_6")}
                              >
                                <AccordionSummary
                                  style={{ border: "none", marginTop: 20 }}
                                  // expandIcon={<AddIcon />}
                                  expandIcon={
                                    state?.expanded_6 ? (
                                      <RemoveIcon
                                        style={{
                                          color:
                                            defaultLabelColors.main_orange_new,
                                        }}
                                      />
                                    ) : (
                                      <AddIcon />
                                    )
                                  } // Dynamic icon change
                                  className="faq-comments"
                                  sx={{
                                    "&.Mui-expanded h3": {
                                      color:
                                        defaultLabelColors?.main_orange_new,
                                    }, // Change h3 color when expanded
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontWeight: "500",
                                      fontFamily: "montserrat-Medium",
                                      fontSize: screen_1024 ? "22px" : "18px",
                                      padding: "20px 0px",
                                    }}
                                  >
                                    Comment est fixé le prix pour l’envoi de mon
                                    colis ?{" "}
                                  </h3>
                                </AccordionSummary>
                                <AccordionDetails
                                  style={{
                                    width: "90%",
                                    fontFamily: "montserrat-Regular",
                                    color: "#4B4A61",
                                    fontSize: 18,
                                  }}
                                >
                                  <p>
                                    Chez Frank, l’expéditeur peut indiquer le
                                    tarif qu’il souhaite pour sa demande de
                                    livraison. Le prix dépendra du poids et des
                                    dimensions du colis, mais aussi de la
                                    distance à parcourir. De leur côté, les
                                    transporteurs peuvent être amenés à négocier
                                    le prix. Une fois que vous avez renseigné
                                    les principales informations concernant
                                    votre colis, Frank vous conseille une
                                    fourchette de prix que vous pouvez suivre.
                                  </p>
                                  <p>
                                    Nous optimisons chaque trajet pour vous
                                    garantir le meilleur rapport qualité-prix,
                                    jusqu'à 50 % moins cher que les
                                    transporteurs classiques. Avec notre
                                    calculateur en ligne, estimez le coût de
                                    votre expédition en quelques clics !
                                  </p>
                                </AccordionDetails>
                              </Accordion>

                              <Accordion
                                elevation={0}
                                style={{
                                  border: "0px",
                                  background: "#FFF8F5",
                                }}
                                expanded={state?.expanded_7}
                                onChange={() => handleExpanded("expanded_7")}
                              >
                                <AccordionSummary
                                  style={{ border: "none", marginTop: 20 }}
                                  // expandIcon={<AddIcon />}
                                  expandIcon={
                                    state?.expanded_7 ? (
                                      <RemoveIcon
                                        style={{
                                          color:
                                            defaultLabelColors.main_orange_new,
                                        }}
                                      />
                                    ) : (
                                      <AddIcon />
                                    )
                                  } // Dynamic icon change
                                  className="faq-comments"
                                  sx={{
                                    "&.Mui-expanded h3": {
                                      color:
                                        defaultLabelColors?.main_orange_new,
                                    }, // Change h3 color when expanded
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontWeight: "500",
                                      fontFamily: "montserrat-Medium",
                                      fontSize: screen_1024 ? "22px" : "18px",
                                      padding: "20px 0px",
                                    }}
                                  >
                                    Quelles sont les zones de livraisons
                                    possibles pour l’envoi de mon colis{" "}
                                  </h3>
                                </AccordionSummary>
                                <AccordionDetails
                                  style={{
                                    width: "90%",
                                    fontFamily: "montserrat-Regular",
                                    color: "#4B4A61",
                                    fontSize: 18,
                                  }}
                                >
                                  <p>
                                    Envoyez vos colis partout en France
                                    métropolitaine, de la grande ville au petit
                                    village. Grâce à notre vaste communauté de
                                    transporteurs particuliers, nous couvrons
                                    même les zones rurales habituellement mal
                                    desservies. Que ce soit pour un trajet
                                    local, régional ou national, il y aura
                                    toujours un Particulier prêt à livrer votre
                                    colis à bon port. Élargissez vos horizons
                                    sans vous ruiner !
                                  </p>
                                </AccordionDetails>
                              </Accordion>
                            </Grid>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  </div>
                </>
              ) : state?.step === 2 ? (
                <div
                  style={{
                    background: defaultLabelColors.main_background_new,
                  }}
                >
                  <PickupInfo
                    handleUpadte={_handleUpdateState}
                    handleUpadateState={handleUpdateState}
                    {...state}
                    {...props}
                  />
                </div>
              ) : state?.step === 3 ? (
                <div
                  style={{
                    background: defaultLabelColors.main_background,
                  }}
                >
                  <DropOffInfo
                    handleUpadte={_handleUpdateState}
                    handleUpadateState={handleUpdateState}
                    {...state}
                    {...props}
                  />
                </div>
              ) : (
                <div
                  style={{
                    background: defaultLabelColors.main_background,
                  }}
                >
                  <ReviewPackage
                    handleUpadte={_handleUpdateState}
                    handleEmptyShipment={handleEmptyShipment}
                    handleUpadateState={handleUpdateState}
                    {...state}
                    {...props}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {screen_1024 ? (
          <div
            className="main-container"
            style={{ background: defaultLabelColors.main_background }}
          >
            <CustomFooter />
          </div>
        ) : (
          <div>
            <CustomMobileFooter />
          </div>
        )}

        <DraggableDialog
          maxWidth={"md"}
          Width={755}
          open={state?.openJobDialog}
          handleClose={() => {
            handleClearAllFeils();
          }}
          dialog_title={strings?.add_item}
          classes={classes}
          dialogBody={
            <DialogContent
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                flexDirection: "column",
              }}
            >
              <Box width={"100%"}>
                <>
                  <Grid container spacing={spacing?.spacing2}>
                    <Grid xs={12} item></Grid>
                    {/* <Grid
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        cursor: "pointer",
                        flexDirection: "column",
                      }}
                      item
                    >
                      <div
                        style={{
                          background: "#F4F3F6",
                          width: "100%",
                          height: "150px",
                          border: `2px dashed ${defaultLabelColors.main_blue}`,
                          borderRadius: "32px",
                        }}
                        className="display-flex"
                        onClick={() => {
                          let { announcement_item } = state;
                          let item_obj = {
                            ...announcement_item,
                          };
                          if (item_obj?.images?.length > 5) {
                            Toast.Error("You cannot add more than 6 pictures");
                            return;
                          }
                          item_obj?.images?.push({});
                          setState({
                            announcement_item: item_obj,
                          });
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontFamily: "Raleway-Variable",
                            color: defaultLabelColors.main_blue,
                            fontSize: "20px",
                            fontWeight: "700",
                            flexDirection: "column",
                            cursor: "pointer",
                          }}
                        >
                          <AddImageIcon fill={defaultLabelColors.main_blue} />
                          {"Ajouter des photos"}
                        </label>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          {state?.announcement_item?.images?.map(
                            (item: any, index: number) => (
                              <div
                                key={"PRODUCTIMAGES_" + index + 1}
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  style={{
                                    height: 100,
                                    width: 100,
                                    borderRadius: 16,
                                    backgroundColor: "white",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 10,
                                    flexWrap: "wrap",
                                    display: "flex",
                                  }}
                                >
                                  {item?.uri || typeof item === "string" ? (
                                    <>
                                      <label
                                        htmlFor={`product_image_back_${
                                          index + 1
                                        }`}
                                      >
                                        <img
                                          src={item?.uri ?? item ?? ""}
                                          alt=""
                                          style={{
                                            height: "110px",
                                            width: "100%",
                                            borderRadius: 16,
                                            objectFit: "contain",
                                          }}
                                        />
                                      </label>
                                      <input
                                        id={`product_image_back_${index + 1}`}
                                        type="file"
                                        className={"inputfile"}
                                        onChange={(e) =>
                                          handleLaunchGallery2(
                                            "images",
                                            index,
                                            e
                                          )
                                        }
                                      />
                                    </>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <label
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                        htmlFor={`product_image_back_${
                                          index + 1
                                        }`}
                                      >
                                        <AddPhotoAlternateOutlined
                                          style={{
                                            color: defaultLabelColors.main_blue,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </label>
                                      <input
                                        id={`product_image_back_${index + 1}`}
                                        type="file"
                                        className={"inputfile"}
                                        onChange={(e) => {
                                          handleLaunchGallery2(
                                            "images",
                                            index,
                                            e
                                          );
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            )
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        ></div>
                      </div>
                    </Grid> */}
                    <Grid
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        cursor: "pointer",
                        flexDirection: "column",
                      }}
                      item
                    >
                      {/* Hidden File Input */}
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none", zIndex: -11111111111 }}
                        onChange={handleFileChange}
                      />

                      {/* Main Div */}
                      {state?.announcement_item?.images < 1 && (
                        <div
                          style={{
                            background: "#FAFAFA",
                            width: "100%",
                            height: "130px",

                            border: `2px dashed ${defaultLabelColors.main_orange_new}`,
                            borderRadius: "32px",
                            gap: 5,
                          }}
                          className="display-flex"
                          onClick={handleClick}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontFamily: "montserrat-Bold",
                              color: defaultLabelColors.main_orange_new,
                              fontSize: "16px",
                              flexDirection: "column",
                              cursor: "pointer",
                            }}
                          >
                            <AddImageIcon
                              height={24}
                              fill={defaultLabelColors.main_orange_new}
                            />
                            {"Ajouter des photos"}
                          </label>
                        </div>
                      )}

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          {state?.announcement_item?.images?.map(
                            (item: any, index: number) => (
                              <div
                                key={"PRODUCTIMAGES_" + index + 1}
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  style={{
                                    height: 100,
                                    width: 100,
                                    borderRadius: 16,
                                    backgroundColor: "white",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 10,
                                    flexWrap: "wrap",
                                    display: "flex",
                                  }}
                                >
                                  {item?.uri || typeof item === "string" ? (
                                    <>
                                      <label
                                        style={{ position: "relative" }}
                                        htmlFor={`product_image_back_${
                                          index + 1
                                        }`}
                                      >
                                        <img
                                          src={item?.uri ?? item ?? ""}
                                          alt="img"
                                          style={{
                                            height: "90px",
                                            width: "90px",
                                            borderRadius: 16,
                                            objectFit: "contain",
                                            zIndex: -111,
                                          }}
                                        />
                                        <Close
                                          style={{
                                            position: "absolute",
                                            cursor: "pointer",
                                            backgroundColor: "#F4F3F6",
                                            borderRadius: "50%",
                                            color: "#000",
                                            height: "15px",
                                            width: "15px",
                                            zIndex: 11111,
                                            padding: 3,
                                            right: 1,
                                            top: -3,
                                          }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleRemoveImage(index);
                                          }}
                                        />
                                      </label>

                                      <input
                                        id={`product_image_back_${index + 1}`}
                                        type="file"
                                        accept="image/*"
                                        // accept=".jpg, .jpeg, .png"
                                        className={"inputfile"}
                                        onChange={(e) =>
                                          handleLaunchGallery2(
                                            "images",
                                            index,
                                            e
                                          )
                                        }
                                      />
                                    </>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <label
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                        htmlFor={`product_image_back_${
                                          index + 1
                                        }`}
                                      >
                                        <AddPhotoAlternateOutlined
                                          style={{
                                            color: defaultLabelColors.main_blue,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </label>
                                      <input
                                        id={`product_image_back_${index + 1}`}
                                        type="file"
                                        accept="image/*"
                                        className={"inputfile"}
                                        onChange={(e) => {
                                          handleLaunchGallery2(
                                            "images",
                                            index,
                                            e
                                          );
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            )
                          )}
                          {state?.announcement_item?.images?.length > 0 &&
                            state?.announcement_item?.images?.length <= 5 && (
                              <div
                                style={{
                                  background: "#FAFAFA",
                                  height: 102,
                                  width: 107,

                                  border: `2px dashed #BCBBC4`,
                                  borderRadius: "16px",
                                  marginLeft: 20,
                                  margin: 10,
                                }}
                                className="display-flex"
                                onClick={handleClick}
                              >
                                <label
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontFamily: "montserrat-Bold",
                                    color: defaultLabelColors.main_orange_new,
                                    fontSize: "16px",
                                    flexDirection: "column",
                                    cursor: "pointer",
                                  }}
                                >
                                  <AddImageIcon
                                    height={24}
                                    fill={defaultLabelColors.main_orange_new}
                                  />
                                </label>
                              </div>
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid xs={12} item>
                      <div
                        style={{
                          background: "#fff",
                          padding: "20px",
                          borderBottom: "1px solid #E9E8EB",
                        }}
                      >
                        <ParcelSizeSelect
                          onChange={handleShipmentTypeChange}
                          selected_value={state?.selected_value}
                        />
                      </div>
                    </Grid>

                    <Grid xs={12} item style={{ display: "flex" }}>
                      <div
                        style={{
                          background: "#fff",
                          padding: "20px",
                          display: "flex",
                          flexDirection: "column",
                          borderBottom: "1px solid #E9E8EB",
                          width: "100%",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            fontFamily: "montserrat-SemiBold",
                            fontSize: "16px",
                            marginBottom: "8px",
                          }}
                        >
                          A propos du colis
                        </p>

                        <Grid xs={12} item>
                          <FormControl
                            fullWidth
                            style={{
                              background: "#fff",
                              borderRadius: "16px",
                              border: "none",
                              outline: "none",
                            }}
                            sx={{
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                            }}
                          >
                            <Select
                              value={`${
                                selectedValue ? transSizes(selectedValue) : ""
                              }`}
                              onChange={handleChange}
                              displayEmpty
                              IconComponent={KeyboardArrowDown}
                              sx={{
                                borderRadius: "16px",
                                background: "#F4F3F6",
                                fontFamily: "montserrat-Regular",
                                fontSize: "16px",
                                color: "#4B4A61",
                                width: "100%",
                                outline: "none",
                                padding: "0px",
                                border: "none",
                                minWidth: "100%",
                              }}
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    border: "1px solid #F4F3F6",
                                    borderRadius: "8px",

                                    "& .MuiMenuItem-root:hover": {
                                      backgroundColor: "#F4F3F6",
                                      borderRadius: "8px",
                                    },
                                    "& .MuiMenuItem-root": {
                                      margin: "4px",
                                    },
                                  },
                                },
                              }}
                              renderValue={
                                (selected) =>
                                  selected ? (
                                    selected
                                  ) : (
                                    <span
                                      style={{
                                        fontFamily: "montserrat-Regular",
                                        color: "#8F8E9C",
                                        fontSize: 16,
                                      }}
                                    >
                                      Sélectionner la taille du colis
                                    </span>
                                  ) // ✅ Placeholder
                              }
                            >
                              {FrankConstants.itemSizes(selector?.lang)?.map(
                                (i: any) => (
                                  <MenuItem key={i.size} value={i.size}>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontFamily: "montserrat-SemiBold",
                                          color: defaultLabelColors.main_font,
                                        }}
                                      >
                                        {i.size_trans}
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          fontFamily: "montserrat-Regular",
                                          color: defaultLabelColors.main_font,
                                        }}
                                      >
                                        {i.weight_fr}:{" "}
                                        <span
                                          style={{
                                            fontSize: "14px",
                                            fontFamily: "montserrat-Regular",
                                            color: defaultLabelColors.main_font,
                                          }}
                                        >
                                          {i.desc}
                                        </span>
                                      </span>
                                    </div>
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          </FormControl>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid xs={12} item>
                      <div
                        style={{
                          background: "#fff",
                          padding: "20px",
                          borderBottom: "1px solid #E9E8EB",
                        }}
                      >
                        <FormGroup>
                          <FormControlLabel
                            style={{ gap: 10 }}
                            control={
                              <IOSSwitch
                                checked={state?.isDimestions} // Use 'checked' instead of 'value'
                                onClick={() => {
                                  setState({
                                    isDimestions: !state?.isDimestions,
                                  });
                                }}
                              />
                            }
                            label="Je connais les dimensions"
                            sx={{
                              ".MuiFormControlLabel-label": {
                                fontFamily: "montserrat-Bold",
                                fontSize: 16,
                              },
                            }}
                          />
                        </FormGroup>
                        {state?.isDimestions ? (
                          <Grid
                            container
                            spacing={2}
                            style={{ display: "flex", paddingTop: 10 }}
                          >
                            <Grid xs={4} item>
                              <span
                                style={{
                                  margin: 0,
                                  paddingLeft: 10,
                                  fontFamily: "montserrat-Regular",
                                  fontSize: "16px",
                                }}
                              >
                                {strings?.length}
                              </span>
                              <InputField
                                input_type={"number"}
                                input_value={state?.prod_length ?? ""}
                                endIicon={
                                  <span
                                    style={{
                                      fontFamily: "montserrat-Regular",
                                      color: "#1E1D3A",
                                    }}
                                  >
                                    cm
                                  </span>
                                }
                                onchange={onInputChangeForDimensions}
                                input_name={"prod_length"}
                                input_style={{
                                  background: "#F4F3F6",
                                  width: "100%",
                                  borderRadius: "16px",
                                  border: "none",
                                  fontFamily: "montserrat-SemiBold",
                                }}
                              />
                            </Grid>
                            <Grid xs={4} item>
                              <span
                                style={{
                                  margin: 0,
                                  paddingLeft: 10,
                                  fontFamily: "montserrat-Regular",
                                  fontSize: "16px",
                                }}
                              >
                                {strings?.width}
                              </span>
                              <InputField
                                input_type={"number"}
                                input_value={state?.prod_width ?? ""}
                                endIicon={
                                  <span
                                    style={{
                                      fontFamily: "montserrat-Regular",
                                      color: "#1E1D3A",
                                    }}
                                  >
                                    cm
                                  </span>
                                }
                                onchange={onInputChangeForDimensions}
                                input_name={"prod_width"}
                                input_style={{
                                  background: "#F4F3F6",
                                  width: "100%",
                                  borderRadius: "16px",
                                  border: "none",
                                  fontFamily: "montserrat-SemiBold",
                                }}
                              />
                            </Grid>
                            <Grid xs={4} item>
                              <span
                                style={{
                                  margin: 0,
                                  paddingLeft: 10,
                                  fontFamily: "montserrat-Regular",
                                  fontSize: "16px",
                                }}
                              >
                                {strings?.height}
                              </span>
                              <InputField
                                input_type={"number"}
                                input_value={state?.prod_height ?? ""}
                                endIicon={
                                  <span
                                    style={{
                                      fontFamily: "montserrat-Regular",
                                      color: "#1E1D3A",
                                    }}
                                  >
                                    cm
                                  </span>
                                }
                                onchange={onInputChangeForDimensions}
                                input_name={"prod_height"}
                                input_style={{
                                  background: "#F4F3F6",
                                  width: "100%",
                                  borderRadius: "16px",
                                  border: "none",
                                  fontSize: "16px",
                                  fontFamily: "montserrat-SemiBold",
                                }}
                              />
                            </Grid>
                          </Grid>
                        ) : null}
                      </div>
                    </Grid>

                    <Grid xs={12} item>
                      <div
                        style={{
                          background: "#fff",
                          padding: "20px",
                          borderBottom: "1px solid #E9E8EB",
                        }}
                      >
                        <FormGroup>
                          <FormControlLabel
                            style={{
                              fontFamily: "Raleway-Variable",
                              fontSize: 22,
                              gap: 10,
                            }}
                            control={
                              <IOSSwitch
                                checked={state?.isFragile} // Use 'checked' instead of 'value'
                                onClick={() => {
                                  setState({
                                    isFragile: !state?.isFragile,
                                  });
                                }}
                              />
                            }
                            sx={{
                              ".MuiFormControlLabel-label": {
                                fontFamily: "montserrat-Bold",
                                fontSize: 16,
                              },
                            }}
                            label={strings?.fragile}
                          />
                        </FormGroup>
                      </div>
                    </Grid>

                    <Grid xs={12} item>
                      <p
                        style={{
                          margin: 0,
                          fontFamily: "montserrat-SemiBold",
                          fontSize: "16px",
                          marginBottom: "8px",
                        }}
                      >
                        Information complémentaire
                      </p>
                      <div
                        style={{
                          background: "#F4F3F6",
                          display: "flex",
                          justifyContent: "flex-start",
                          borderBottom: "1px solid #E9E8EB",
                          borderRadius: "12px",
                        }}
                      >
                        {/* <InputField
                          placeHolder={"Information complémentaire"}
                          isMultiLine={true}
                          input_rows={3}
                          input_type={"text"}
                          input_value={state.additional_info ?? ""}
                          onchange={onInputChange}
                          input_name={"additional_info"}
                          input_style={{
                            background: "#F4F3F6",
                            width: "99%",
                            borderRadius: 12,
                            border: "none",
                            fontSize: "16px",
                            padding: 0,
                          }}
                        /> */}
                        <TextField
                                            placeholder="Information complémentaire"
                                            variant="outlined"
                                            fullWidth
                                            type="text"
                                            value={state.additional_info ?? ""}
                                            name="additional_info"
                                            onChange={onInputChange}
                                            maxRows={3}
                                            minRows={3}
                                            multiline
                                            InputProps={{
                                              sx: {
                                                backgroundColor: "#F4F3F6",
                                                fontFamily: "montserrat-Regular",
                                                border: "none",
                        
                                                "& fieldset": {
                                                  border: "none",
                                                },
                                              },
                                            }}
                                            sx={{
                                              "& .MuiOutlinedInput-root": {
                                                borderRadius: "16px", // Optional: rounded corners
                                              },
                                            }}
                                          />
                      </div>
                    </Grid>

                    <Grid xs={12} item>
                      <Box
                        sx={{
                          background: "#fff",
                          padding: "20px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderBottom: "1px solid #E9E8EB",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontSize: 16,
                            fontFamily: "montserrat-SemiBold",
                            flex: 1,
                          }}
                        >
                          Combien de colis de cette dimension souhaitez vous
                          envoyer:
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <IconButton
                            onClick={() => {
                              handleIncrmntDecrmnt("decrement");
                            }}
                            className="custom-icon-btn"
                          >
                            <Remove />
                          </IconButton>
                          <Typography
                            variant="h6"
                            sx={{
                              margin: "0 15px",
                              minWidth: "20px",
                              textAlign: "center",
                              fontSize: "28px",
                              fontFamily: "montserrat-Bold",
                            }}
                          >
                            {state?.item_quantity ?? 1}
                          </Typography>
                          <IconButton
                            onClick={() => {
                              handleIncrmntDecrmnt("increament");
                            }}
                            className="custom-icon-btn"
                          >
                            <Add />
                          </IconButton>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              </Box>
            </DialogContent>
          }
          dialogFooter={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                padding: "20px",
                gap: "10px",
              }}
            >
              <CustomButton
                classesNames={"outline_button_for_nego"}
                value={"Annuler"}
                onClick={handleClearAllFeils}
                style={{ minWidth: "145px" }}
              />

              {state?.isUpdate ? (
                <CustomButton
                  classesNames={"contained_button_for_nego"}
                  value={"Update"}
                  style={{ minWidth: "145px" }}
                  onClick={handleUpdateShipment}
                />
              ) : (
                <CustomButton
                  classesNames={"contained_button_for_nego"}
                  value={"Ajouter"}
                  style={{ minWidth: "145px" }}
                  onClick={handleAddShipment}
                />
              )}
            </div>
          }
        />

        <DraggableDialog
          maxWidth={"md"}
          open={state?.openLoginDialog}
          handleClose={() => {
            setState({ openLoginDialog: false });
          }}
          classes={classes}
          dialogBody={
            <DialogContent
              style={{
                display: "flex",
                background: "#FCE6DD",
              }}
              dividers
            >
              <Grid container spacing={spacing.spacing2}>
                <Grid xs={12} item>
                  <AuthAction
                    {...state}
                    {...props}
                    handleCloseLoginPage={handleCloseLoginPage}
                  />
                </Grid>
              </Grid>
            </DialogContent>
          }
        />
      </div>

      {/* Mobile Responsive code <div className="mobile-screen" style={{ width: "100%" }}>
        <SendPackageMobileView
          {...state}
          {...props}
          selectedValue={selectedValue}
          handleGetItemList={handleGetItemList}
          handleShipmentTypeChange={handleShipmentTypeChange}
          onInputChange={onInputChange}
          handleIncrmntDecrmnt={handleIncrmntDecrmnt}
          handleClearAllFeils={handleClearAllFeils}
          handleUpdateShipment={handleUpdateShipment}
          handleAddShipment={handleAddShipment}
          handleLaunchGallery2={handleLaunchGallery2}
          setSelectedValue={setSelectedValue}
          handleCloseLoginPage={handleCloseLoginPage}
          EditShipmentItem={EditShipmentItem}
          handleRemoveItem={handleRemoveItem}
          handleEmptyShipment={handleEmptyShipment}
          handleOpenDialog={handleOpenDialog}
          handleContinue={handleContinue}
          handleRemoveImage={handleRemoveImage}
          handleUpadateState={handleUpdateState}
          handleUpadte={_handleUpdateState}
        />
      </div> */}

      <div className="mobile-screen">
        <MobileResponsive />
      </div>
    </>
  );
}

export default SendPackage;
